/*
 * Decléor — Force the REAL cart total on the checkout button / cart total.
 * ---------------------------------------------------------------------------
 * Safety net for when a cart app (e.g. a "free shipping bar" / upsell app) inflates the DISPLAYED
 * total by injecting an estimated shipping amount into <span data-cart-final> — even though the real
 * cart (cart.total_price) has no such line. This keeps [data-cart-final] equal to the real cart total
 * (formatted like the theme, with/without the currency code per the "Hide currency code" setting),
 * re-asserting it whenever the app rewrites it (MutationObserver). It is HONEST: the real cart and the
 * checkout are unchanged (shipping is still calculated at checkout); only the misleading display is fixed.
 *
 * Real total comes from theme:cart:change/init (event.detail.cart.total_price) and a one-time /cart.js
 * read on load. The equality guard prevents an observer loop. No-op if window.theme.moneyFormat is absent.
 */
(function () {
  'use strict';

  var tag = document.currentScript || document.querySelector('script[data-cart-fix-total]');
  var HIDE_CODE = !!(tag && tag.getAttribute('data-hide-code') === 'true');
  var FMT = (window.theme && window.theme.moneyFormat) || '';
  if (!FMT) { return; }
  var CODE = (window.theme && window.theme.currencyCode) || '';

  function formatMoney(cents, format) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function n(number, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) { return '0'; }
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    if (!m) { return format; }
    var v;
    switch (m[1]) {
      case 'amount': v = n(cents, 2); break;
      case 'amount_no_decimals': v = n(cents, 0); break;
      case 'amount_with_comma_separator': v = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = n(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = n(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': v = n(cents, 2, "'", '.'); break;
      default: v = n(cents, 2);
    }
    return format.replace(re, v);
  }

  function want(cents) {
    var s = formatMoney(Math.round(cents), FMT);
    if (!HIDE_CODE && CODE && s.indexOf(CODE) === -1) { s = s + ' ' + CODE; }
    return s;
  }

  var real = null;

  function apply() {
    if (real == null) { return; }
    var w = want(real);
    document.querySelectorAll('[data-cart-final]').forEach(function (el) {
      if (el.textContent.trim() !== w) { el.textContent = w; } // guard: only write on change → no observer loop
    });
  }

  function observe() {
    document.querySelectorAll('[data-cart-final]').forEach(function (el) {
      if (el.__fixTotal) { return; }
      el.__fixTotal = 1;
      new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function setFrom(e) {
    if (e && e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      real = e.detail.cart.total_price;
    }
    observe();
    apply();
  }

  document.addEventListener('theme:cart:change', setFrom);
  document.addEventListener('theme:cart:init', setFrom);

  // One-time authoritative read for the initial paint.
  var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (c) { real = c.total_price; observe(); apply(); })
    .catch(function () { /* leave server-rendered value */ });
})();
